import React, { useContext, useState } from 'react'
import { diamond, User } from "../assets";
import { AuthContext } from '../context/AuthContext';
import { useMy } from '../code/My';
import { useRates } from '../code/Rates';
import { Link } from 'react-router-dom';
import CurrencyModal from '../components/CurrencyModal';
import LanguageModal from '../LanguageModal';
import { RiLogoutCircleRLine } from "react-icons/ri";
import { MdOutlineGTranslate } from "react-icons/md";

const Wallet = () => {
  const my = useMy();
  const { selectedCurrency, convertBalance } = useRates();
  const { currentUser } = useContext(AuthContext);

  const [showModal, setShowModal] = useState(false);
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const currency = localStorage.getItem("currency");

  // Referral code logic
  const referralCode = my?.referralCode || currentUser?.referralCode;
  const referralLink = `${process.env.REACT_APP_BASE_URL}/register?ref=${referralCode}`;

  const handleShare = async () => {
    if (navigator.share) {
      // If the Web Share API is supported
      try {
        await navigator.share({
          title: 'Join my referral program!',
          text: 'Check out this awesome offer!',
          url: referralLink,
        });
        console.log('Shared successfully!');
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      // Fallback for browsers that do not support the Web Share API
      const whatsappUrl = `https://wa.me/?text=Check%20out%20this%20awesome%20offer!%20${encodeURIComponent(referralLink)}`;

      // Open WhatsApp (mobile app or web)
      window.open(whatsappUrl, '_blank');
    }
  };

  return (
    <>
      <div className="w-full h-[250px] flex flex-col bg-gradient-to-t from-rose-700 via-rose-400 to-white gap-2 items-center justify-center pb-4 rounded-b-[24px]">
        <div className="bg-white rounded-[24px] flex flex-col w-[80%] items-center justify-center p-4 gap-1">
          <div className='flex w-full items-center justify-between'>
            <div className='gap-2 flex'>
              <div onClick={() => setShowModal(true)} className='h-[40px] w-[40px] flex bg-gray-100 hover:bg-white cursor-pointer rounded-[12px] border items-center justify-center'>{currency}</div>
              {showModal && <CurrencyModal onClose={() => setShowModal(false)} />}
            </div>
            <div className="pb-1">BALANCE</div>
            <div className='gap-2 flex'>
              <div className='h-[40px] w-[40px] flex bg-gray-100 hover:bg-gray-200 cursor-pointer rounded-full border items-center justify-center'>
                <img src={User} alt={currentUser?.username} className="h-[40px] w-[40px] object-cover shrink-0" />
              </div>
            </div>
          </div>
          <div className="font-bold text-[28px] text-orange-600 leading-[1]">{my?.balance || currentUser?.balance} UXB</div>
          <div className="font-bold text-[44px] leading-[1]">
            <span className="text-[18px]">{selectedCurrency} </span>
            {convertBalance(my?.balance || currentUser?.balance)}
          </div>
        </div>
        <div className="flex gap-2">
          <Link to={`/agents`} className="bg-zinc-100 rounded-[12px] hover:bg-zinc-200 p-2 h-[40px] min-w-[100px] text-center w-fit px-4 cursor-pointer">Deposit</Link>
          <Link to={`/withdraw`} className="bg-zinc-100 rounded-[12px] hover:bg-zinc-200 p-2 h-[40px] min-w-[100px] text-center w-fit px-4 cursor-pointer">Withdraw</Link>
        </div>
        <div className='flex w-full items-center justify-between px-2'>
          <div className='gap-2 flex'>
            <MdOutlineGTranslate title="English" onClick={() => setShowLanguageModal(true)} className='h-[40px] w-[40px] p-[7px] flex text-white hover:text-rose-700 hover:bg-white cursor-pointer rounded-[12px] border items-center justify-center' />
            {showLanguageModal && <LanguageModal onClose={() => setShowLanguageModal(false)} />}
          </div>
          <div className="font-bold text-white text-center w-full">Friday 6, June 2025</div>
          <div className='gap-2 flex'>
            <Link to='/logout' title="LOGOUT" className='h-[40px] w-[40px] p-[7px] flex text-white hover:text-rose-700 hover:bg-gray-200 cursor-pointer rounded-full border items-center justify-center'>
              <RiLogoutCircleRLine className="h-full w-full object-cover shrink-0" />
            </Link>
          </div>
        </div>
      </div>

      <div className="w-full h-fit my-2 flex flex-col bg-neutral-100 gap-1 justify-center p-2 px-4 rounded-[24px]">
        <div className="flex w-full items-center justify-between">
          <div className="font-bold">{my?.level.name || currentUser?.level.name} user</div>
          {currentUser?.daysSinceLevelAssigned && <div className="text-rose-500">{my?.daysSinceLevelAssigned || currentUser?.daysSinceLevelAssigned}th Day</div>}
        </div>
        <div className="">
          <div className="">{selectedCurrency} {convertBalance(my?.level.amount || currentUser?.level.amount)} | {my?.level.amount || currentUser?.level.amount} Uxbroot</div>
          <div className="text-[12px]">Earns {selectedCurrency} {convertBalance(my?.level.earnings || currentUser?.level.earnings)} per day</div>
        </div>
      </div>
      <div className="flex w-full items-center justify-between h-fit">
        <div className="">Referral ID : <span className="font-bold">{my?.referralCode || currentUser?.referralCode}</span></div>
        <button
          onClick={handleShare}
          className="text-green-500 cursor-pointer flex p-2 h-[40px] w-[40%] bg-slate-100 hover:bg-slate-200 items-center justify-center rounded-[12px]"
        >
          Share Link
        </button>
      </div>
      <div className="flex w-full items-center justify-between gap-2 my-2">
        <div className="flex flex-col w-[50%] bg-gray-100 p-4 rounded-[12px]">
          <div className="font-bold">Privilege Cash</div>
          <div className="">{selectedCurrency} {convertBalance(my?.privilege_cash || currentUser?.privilege_cash || 0)}</div>
        </div>
        <div className="flex flex-col w-[50%] bg-gray-100 p-4 rounded-[12px]">
          <div className="font-bold">Referral Earn</div>
          <div className="">{selectedCurrency} {convertBalance(my?.referralEarn || currentUser?.referralEarn)}</div>
        </div>
      </div>
      <div className="flex flex-col w-full my-2 gap-1 mb-20">
        <div className="font-bold"></div>
        <div className="flex flex-col gap-[2px]"></div>
      </div>
    </>
  )
}

export default Wallet
